export default __webpack_public_path__ + "static/media/device_marker_green.54c3cacc.svg";